var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaymentIconMastercardColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.58 21H2.42A2.4 2.4 0 010 18.62V4.38A2.4 2.4 0 012.42 2h24.16A2.4 2.4 0 0129 4.38v14.25A2.4 2.4 0 0126.58 21z",
    fill: "#003663"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.5a6.5 6.5 0 1113 0 6.5 6.5 0 11-13 0",
    fill: "#EB1C26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.5a6.5 6.5 0 1113 0 6.5 6.5 0 11-13 0",
    fill: "#F99F1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6.38a6.49 6.49 0 000 10.24 6.49 6.49 0 000-10.24z",
    fill: "#EF5D20"
  })));
}

export default SvgPaymentIconMastercardColor;